import Funcs from 'common/helpers/Funcs';
import Navigation from 'common/services/NavigationService';
import StorageService from 'common/services/StorageService';
import ScreenConst from 'consts/ScreenConst';
import StorageConst from 'consts/StorageConst';
import Realms from 'realm/Realms';
import AppProvider from 'states/context/providers/AppProvider';
import Utils from 'utils/Utils';

const AppAction = {
  removeAds: () => {
    AppProvider.instance?.setState({ removeAds: true });
  },
  changeLanguage: (language) => {
    AppProvider.instance?.setState({ language });
  },
  updateCoins: (coins) => {
    AppProvider.instance?.setState({ coins });
  },
  changeWarehouse: (currentWarehouse) => {
    AppProvider.instance?.setState({ currentWarehouse });
  },
  ///////////////////////////Đang dở dang phần bỏ update từ appcontext, note chưa cập nhật.

  // Order
  onCreatedOrder: (createdOrder) => {
    AppProvider.instance?.setState({ createdOrder });
  },
  onDeleteOrder: (deleteOrder) => {
    AppProvider.instance?.setState({ deleteOrder });
  },
  onEditedOrder: (editedOrder) => {
    AppProvider.instance?.setState({ editedOrder });
  },

  // Customer
  onCreatedCustomer: (createdCustomer) => {
    StorageService.remove(StorageConst.HAS_LOCAL_DATA);
    AppProvider.instance?.setState({ createdCustomer });
  },
  onDeleteCustomer: (deleteCustomer) => {
    StorageService.remove(StorageConst.HAS_LOCAL_DATA);
    AppProvider.instance?.setState({ deleteCustomer });
  },
  onEditedCustomer: (editedCustomer) => {
    StorageService.remove(StorageConst.HAS_LOCAL_DATA);
    AppProvider.instance?.setState({ editedCustomer });
  },

  // Provider
  onCreatedProvider: (createdProvider) => {
    AppProvider.instance?.setState({ createdProvider });
  },
  onDeleteProvider: (deleteProvider) => {
    AppProvider.instance?.setState({ deleteProvider });
  },
  onEditedProvider: (editedProvider) => {
    AppProvider.instance?.setState({ editedProvider });
  },

  // Context
  onCreatedCategory: (createdCategory) => {
    AppProvider.instance?.setState({ createdCategory });
    Utils.static.categories = [];
  },
  onDeleteCategory: (deleteCategory) => {
    AppProvider.instance?.setState({ deleteCategory });
    Utils.static.categories = [];
  },
  onEditedCategory: (editedCategory) => {
    AppProvider.instance?.setState({ editedCategory });
    Utils.static.categories = [];
  },

  onEditedCustomerGroup: (editedCustomerGroup) => {
    AppProvider.instance?.setState({ editedCustomerGroup });
    Utils.static.categories = [];
  },
  onDeleteCustomerGroup: (deleteCustomerGroup) => {
    AppProvider.instance?.setState({ deleteCustomerGroup });
  },
  onCreatedCustomerGroup: (createdCustomerGroup) => {
    AppProvider.instance?.setState({ createdCustomerGroup });
  },

  onCreatedUnit: (createdUnit) => {
    AppProvider.instance?.setState({ createdUnit });
    Utils.static.units = [];
  },
  onDeleteUnit: (deleteUnit) => {
    AppProvider.instance?.setState({ deleteUnit });
    Utils.static.units = [];
  },
  onEditUnit: (editedUnit) => {
    AppProvider.instance?.setState({ editedUnit });
    Utils.static.units = [];
  },

  onCreatedComposition: (createdComposition) => {
    AppProvider.instance?.setState({ createdComposition });
  },
  onDeleteComposition: (deleteComposition) => {
    AppProvider.instance?.setState({ deleteComposition });
  },
  onEditComposition: (editedComposition) => {
    AppProvider.instance?.setState({ editedComposition });
  },

  onCreatedWarehouse: (createdWarehouse) => {
    AppProvider.instance?.setState({ createdWarehouse });
  },
  onEditedWarehouse: (editedWarehouse) => {
    AppProvider.instance?.setState({ editedWarehouse });
  },

  // Backup db
  updateDatabase: async (isUpdateDatabase = true) => {
    Realms.close();
    await Funcs.delay(200);
    await Realms.init();
    await Utils.init();
    await Funcs.delay(200);
    // AppProvider.instance?.setState({ isUpdateDatabase });
    Navigation.reset(ScreenConst.HOME_SCREEN);
  },
  updateUserData: async (userData) => {
    AppProvider.instance?.setState({ userData });
  },
  updateOrientation: async (isLandscape) => {
    AppProvider.instance?.setState({ isLandscape });
  }
};

export default AppAction;
